import { addPositiveToast, addNegativeToastWithErrorId } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { useInAppRecallMutation } from 'modules/campaigns/lib';
import { useCampaignContext, useModalContext, ModalType } from '../../context';
import { maybeRestErrorMessage } from '../../utils';
import { getInAppRecallPayload } from './InAppRecallModal.utils';

export const useInAppRecall = () => {
  const { closeModal } = useModalContext();
  const { isLoading, mutate, error } = useInAppRecallMutation();
  const { campaign, refetch: refetchCampaign } = useCampaignContext();
  const dispatch = useDispatch();

  const recallInApp = () => {
    const onSuccess = () => {
      dispatch(addPositiveToast(`Recalling ${campaign.name}...`));
      closeModal(ModalType.InAppRecallModal);
      refetchCampaign();
    };

    const onError = (e: unknown) => {
      const errorResponseMessage = maybeRestErrorMessage(e);
      const defaultErrorMessage = `Error recalling ${campaign.name}.`;
      const errorMessage = errorResponseMessage || defaultErrorMessage;
      dispatch(addNegativeToastWithErrorId(errorMessage, 'recallInApp', e));

      closeModal(ModalType.InAppRecallModal);
    };

    const payload = getInAppRecallPayload(campaign);

    mutate(payload, {
      onSuccess,
      onError,
    });
  };

  return { isLoading, error, recallInApp };
};
